// import formValidation from '../vendors/formvalidation/core/Core'
// import notEmpty from '../vendors/formvalidation/validators/notEmpty'
// import submitButton from '../vendors/formvalidation/plugins/SubmitButton'
import reviews from '../partials/reviews';

export default {
  init() {
    reviews();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js